'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

var _KeyboardArrowDown = require('@material-ui/icons/KeyboardArrowDown');

var _KeyboardArrowDown2 = _interopRequireDefault(_KeyboardArrowDown);

var _form = require('../../schema/component/form.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */


var schema = _form.properties.select.properties;

var useStyles = (0, _core.makeStyles)({
  container: {
    width: '100%',
    '& .MuiSelect-select:focus': {
      background: 'none'
    },
    // Root
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--outline)'
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
      height: '54px'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--primary-500)'
    },
    // Input
    '& .MuiOutlinedInput-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '&:hover .MuiOutlinedInput-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '& .MuiFilledInput-underline:after': {
      borderBottom: '2px solid var(--primary-500)'
    },
    '& .MuiSelect-iconOutlined': {
      right: '11px'
    },
    '& .MuiSelect-iconFilled': {
      right: '11px'
    },
    '& .MuiSelect-icon': {
      right: '11px'
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-iconOutlined': {
      color: 'var(--primary-500)'
    },
    '& .MuiFilledInput-root.Mui-focused .MuiSelect-iconFilled': {
      color: 'var(--primary-500)'
    },
    '& .MuiInput-root.Mui-focused .MuiSelect-icon': {
      color: 'var(--primary-500)'
    },
    '& .MuiFilledInput-input': {
      padding: '16px 12px 16px'
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none'
    },
    '& .MuiSelect-filled.MuiSelect-filled': {
      padding: '25px 12px 7px'
    },
    // Label
    '& .MuiInputLabel-outlined': {
      color: 'var(--onsurface-medium-emphasis)',
      marginTop: '-4px'
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      background: 'var(--onprimary-high-emphasis)',
      color: 'var(--primary-500) !important',
      fontSize: '14px',
      padding: '0px 8px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'var(--primary-900) !important'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      marginTop: '0px'
    },
    '& .MuiInputLabel-shrink.MuiInputLabel-outlined.MuiFormLabel-filled': {
      background: 'var(--onprimary-high-emphasis)',
      padding: '0px 8px'
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl legend': {
      maxWidth: '0px'
    },
    '& .MuiInputLabel-filled': {
      marginTop: '-3px'
    },
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      marginTop: '0px'
    },
    // Error
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'var(--error)',
      borderWidth: '2px'
    },
    '& .MuiInputLabel-outlined.Mui-error': {
      color: 'var(--error) !important'
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: 'var(--error)'
    },
    '& .MuiFormLabel-root.Mui-error': {
      color: 'var(--error) !important'
    },
    '& .MuiFilledInput-underline.Mui-error:after': {
      borderBottomColor: 'var(--error)'
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiSelect-iconOutlined': {
      color: 'var(--error)'
    },
    '& .MuiFilledInput-root.Mui-error .MuiSelect-iconFilled': {
      color: 'var(--error)'
    },
    '& .MuiInput-root.Mui-error .MuiSelect-icon': {
      color: 'var(--error)'
    },
    // Standard
    '& .MuiInputBase-root .MuiInputBase-input': {
      color: 'var(--onsurface-high-emphasis)'
    },
    '& .MuiInput-underline:after': {
      borderColor: 'var(--outline)'
    },
    '& .MuiInput-underline.Mui-focused:after': {
      borderColor: 'var(--primary-500)'
    },
    '& .MuiInput-underline.MuiInputBase-adornedEnd:before': {
      borderBottom: '1px solid var(--primary-500)'
    },
    '& .MuiInput-underline.Mui-error:after': {
      borderBottomColor: 'var(--error)'
    },
    '& .MuiInput-underline .MuiSvgIcon-root.icon-filled': {
      color: 'var(--primary-700)'
    },
    '& .MuiInput-underline .MuiSvgIcon-root.icon-error': {
      color: 'var(--error)'
    }
  }
});

var Select = function Select(_ref) {
  var id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      IconComponent = _ref.IconComponent,
      error = _ref.error,
      options = _ref.options,
      shrink = _ref.shrink,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ['id', 'label', 'onChange', 'value', 'IconComponent', 'error', 'options', 'shrink', 'variant']);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      valueState = _useState2[0],
      setValueState = _useState2[1];

  var classes = useStyles();
  return _react2.default.createElement(
    _core.FormControl,
    _extends({
      className: classes.container,
      variant: variant,
      error: error !== ''
    }, props),
    _react2.default.createElement(
      _core.InputLabel,
      {
        id: id + '-label',
        shrink: shrink || (value || valueState ? true : shrink)
      },
      label
    ),
    _react2.default.createElement(
      _core.Select,
      {
        labelId: id + '-label',
        id: id,
        value: value || valueState,
        onChange: onChange || function (e) {
          return setValueState(e.target.value);
        },
        IconComponent: IconComponent || _KeyboardArrowDown2.default,
        label: label
      },
      options && options.map(function (row) {
        return _react2.default.createElement(
          _core.MenuItem,
          { key: row, value: row.value },
          row.label
        );
      })
    ),
    error !== '' && _react2.default.createElement(
      _core.FormHelperText,
      { className: 'form-' + id + '--error' },
      error
    )
  );
};

exports.Select = Select;
var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);

Select.defaultProps = {
  error: schema.error,
  IconComponent: schema.IconComponent,
  id: schema.id,
  label: schema.label,
  onChange: schema.onChange,
  options: schema.options,
  shrink: schema.shrink,
  variant: schema.variant,
  value: schema.value
};

Select.propTypes = {
  error: _propTypes2.default.string,
  IconComponent: _propTypes2.default.node,
  id: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: stringOrNumber,
    value: stringOrNumber
  })),
  shrink: _propTypes2.default.bool,
  variant: _propTypes2.default.string,
  value: stringOrNumber
};

exports.default = Select;